import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAlumniAuth } from "../../contexts/AlumniAuthContext";
import styles from "./AlumniLayout.module.css";

const AlumniLayout = () => {
  const { logout } = useAlumniAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/alumni/login", { replace: true });
  };

  const linkClass = ({ isActive }) =>
    isActive ? `${styles.navLink} ${styles.navLinkActive}` : styles.navLink;

  return (
    <div className={styles.shell}>
      <header className={styles.topbar}>
        <p className={styles.brand}>Pratibha Poshak Alumni</p>
        <nav className={styles.nav}>
          <NavLink to="/alumni/dashboard" className={linkClass}>Dashboard</NavLink>
          <NavLink to="/alumni/profile" className={linkClass}>My Profile</NavLink>
          <NavLink to="/alumni/directory" className={linkClass}>Directory</NavLink>
          <NavLink to="/alumni/community" className={linkClass}>Community</NavLink>
        </nav>
        <button type="button" className={styles.logoutBtn} onClick={handleLogout}>
          Logout
        </button>
      </header>
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};

export default AlumniLayout;
